import DuvalPentagonVisualization from './DuvalPentagonVisualization';
import './DuvalPentagonVisualization.scss';

export { schema, uiSchema } from '../schemas/DuvalPentagonVisualizationSchema';
export default DuvalPentagonVisualization;
